<template>
  <img src="../../../assets/img/avatars/avatar9.jpg" alt="avatar9">
</template>
